//
// POST assets/fromtemplates (PLAN-073, spec 3.3): one asset per template id. The server side is
// REDLAB.ISOPlanner.Core/Data/DTOs/Asset/AssetsFromTemplatesDTO.cs and AssetsFromTemplatesResultDTO.cs.
//

export class AssetsFromTemplatesDTO {
  templateIds: number[];

  constructor(templateIds: number[] = []) {
    this.templateIds = templateIds;
  }
}

export class AssetFromTemplateCreatedDTO {
  templateId: number;

  assetId: number;

  constructor() {
    this.templateId = 0;
    this.assetId = 0;
  }
}

export class AssetFromTemplateSkippedDTO {
  templateId: number;

  /**
   * The ControllerException code of the refusal: ASSET0004 for a name already in the register, IP0002 for an unknown
   * template, the code of a create that failed; null for a failure without one.
   */
  code: string | null;

  reason: string;

  /** The register asset whose name matches, on ASSET0004. */
  assetId?: number;

  assetName?: string;

  constructor() {
    this.templateId = 0;
    this.code = '';
    this.reason = '';
  }
}

export class AssetsFromTemplatesResultDTO {
  created: AssetFromTemplateCreatedDTO[];

  skipped: AssetFromTemplateSkippedDTO[];

  constructor() {
    this.created = [];
    this.skipped = [];
  }
}
